/**
 * 加载状态组件 — 基于 MUI CircularProgress。
 * 支持全页加载和行内加载两种模式。
 */
import { Box, CircularProgress, Typography } from "@mui/material";

export interface LoadingProps {
  /** 是否全页模式（居中 + 大 spinner）。 */
  fullPage?: boolean;
  /** 提示文字。 */
  text?: string;
  /** 最小高度（fullPage 模式下）。 */
  minHeight?: number | string;
}

export default function Loading({
  fullPage = false,
  text = "加载中...",
  minHeight = 300,
}: LoadingProps) {
  if (fullPage) {
    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          minHeight,
          gap: 1.5,
        }}
      >
        <CircularProgress size={36} sx={{ color: "primary.main" }} />
        <Typography sx={{ fontSize: 13, color: "text.secondary" }}>{text}</Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
      <CircularProgress size={16} sx={{ color: "primary.main" }} />
      <Typography sx={{ fontSize: 13, color: "text.secondary" }}>{text}</Typography>
    </Box>
  );
}
